import { Box, Divider, Typography } from "@mui/material";
import { useState } from "react";
import SearchFilter from "../../components/filters/SearchFilter";
import IntegrationRowFilter from "../../scenes/posture/steps/components/IntegrationRowFilter";

/**
 * Demo component for SearchFilter
 * Shows how to implement a searchable dropdown filter with IntegrationRowFilter components
 */
const SearchFilterDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({
    tools: {},
  });

  // Sample tool options
  const toolOptions = ["All", "aws", "okta", "azure", "github"];

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="subtitle2">
        SearchFilter with IntegrationRowFilter:
      </Typography>
      <Box maxWidth={300}>
        {/* Tool Filter with SearchFilter */}
        <SearchFilter
          filterName="Tool"
          fieldName="tools"
          options={toolOptions.map((tool) => {
            if (tool === "All") {
              return {
                name: tool,
                label: <Typography variant="caption">All Tools</Typography>,
                displayName: tool,
              };
            } else {
              return {
                name: tool,
                label: <IntegrationRowFilter name={tool} />,
                displayName: tool,
              };
            }
          })}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          fullOptions={toolOptions}
        />
      </Box>

      <Divider />

      <Typography variant="subtitle2">Selected Tools:</Typography>
      <pre
        style={{
          backgroundColor: "#f5f5f5",
          padding: "12px",
          borderRadius: "4px",
          fontSize: "0.8rem",
          overflow: "auto",
        }}
      >
        {JSON.stringify(appliedFilters, null, 2)}
      </pre>
    </Box>
  );
};

export default SearchFilterDemo;
